import { render } from "./avatar-element-slide-selector.vue?vue&type=template&id=25cb3e6e"
import script from "./avatar-element-slide-selector.vue?vue&type=script&lang=js"
export * from "./avatar-element-slide-selector.vue?vue&type=script&lang=js"

import "./avatar-element-slide-selector.vue?vue&type=style&index=0&id=25cb3e6e&lang=css"
script.render = render

export default script